import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";

Vue.prototype.$operacoes_logins = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      operacoesLoginAddEdit: "new",
      cadastro: {
        loading: false,
        idlogin: "",
        descricao: "",
        ativo: "",
        ordem: "",
        visivel: "",
        classe: "",
        cor_botao: "",
        icone: {
          imagem: "",
        },
        error: {
          descricao: [],
          ativo: [],
          ordem: [],
          visivel: [],
          classe: [],
          cor_botao: [],
          icone: [],
        },
      },
      logins: [],
    };
  },
  methods: {
    // ---- LISTAR LOGINS ---- //
    getLogins() {
      this.$axios.get(this.ENDPOINTS.LISTAR_LOGINS).then(response => {
        this.logins = response;
      });
    },

    // ---- DESABILITAR LOGIN ---- //
    deletarLogin(idsegmento) {
      this.$axios
        .delete(this.ENDPOINTS.DELETAR_SEGMENTO + idsegmento)
        .then(response => {
          if (response) {
            document.location.reload();
          }
        });
    },

    // ---- ALTERAR LOGIN ---- //
    alterarLogin() {
      let dados = {
        descricao: this.cadastro.descricao,
        ativo: this.cadastro.ativo,
      };

      this.$axios
        .put(this.ENDPOINTS.ALTERAR_SEGMENTO + this.cadastro.idsegmento, dados)
        .then(response => {
          if (response) {
            this.$axios.setLocal("confirmEditSegmento", true);
            document.getElementsByClassName(
              "modal-body-segmento-add"
            )[0].style.display = "none";
            (this.cadastro.descricao = ""),
              (this.cadastro.ativo = ""),
              document.location.reload();
          }
        });
    },

    // ---- CADASTRAR LOGIN ---- //
    async cadastrarLogin() {
      this.cadastro.loading = true;
      let dados = {
        descricao: this.cadastro.descricao,
        ativo: this.cadastro.ativo,
      };

      this.$axios
        .post(this.ENDPOINTS.CADASTRAR_SEGMENTO, dados)
        .then(response => {
          if (response) {
            (this.cadastro.descricao = ""),
              (this.cadastro.ativo = ""),
              (document.getElementsByClassName(
                "modal-body-segmento-add"
              )[0].style.display = "none");
            document.location.reload();
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    // ---- // ---------------------------------------- FUNÇÕES AUXILIARES ---------------------------------------- // ---- //

    // ---- FUNÇÃO QUE VALIDA O CADASTRO ---- //
    async validarCadastro() {
      if (this.cadastro.descricao == "") {
        this.$config.alert(
          "Preencha a descrição do segmento!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.descricao = "Preencha a descrição do segmento!";
        return;
      }

      if (this.cadastro.ativo == null) {
        this.$config.alert(
          "Selecione o status!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.ativo = "Selecione o status!";
        return;
      }

      if (this.segmentoAddOrEdit == "edit") {
        this.alterarSegmento();
      } else {
        this.cadastrarSegmento();
      }
    },
  },
});
